import { useCallback } from 'react';
import { useFormTemplateContext } from '../EditFormTemplatePage/FormTemplateContext';
import { useFormTemplateUpdate } from '../EditFormTemplatePage/hooks/useFormTemplateUpdate';
import { EditableFormTemplate } from '../FormTemplateEditor/types';
import { WizardStep } from '../shared/consts';
import { useNavigateToFormTemplateWizardStep } from '../shared/useNavigateToFormTemplateWizardStep';

export function useSubmitFormTemplateDetails({
  formTemplate,
  formWizardBasePath,
  isEditMode,
  organizationId,
}: {
  formTemplate: EditableFormTemplate;
  formWizardBasePath: string;
  isEditMode: boolean;
  organizationId?: string;
}) {
  const { resetDirtyState } = useFormTemplateContext();
  const [saveUpdatedFormTemplate] = useFormTemplateUpdate({
    resetDirtyState,
  });

  const navigateToFieldsStepInCreateMode = useNavigateToFormTemplateWizardStep({
    stepToGoTo: WizardStep.FIELDS,
    formTemplateSlug: null,
    formWizardBasePath,
  });

  const onSubmit = useCallback(async () => {
    if (!isEditMode) {
      navigateToFieldsStepInCreateMode();
      return;
    }

    // mostly to appease ts, and just catch us using this wrong
    if (!organizationId) {
      throw new Error(
        'OrganizationId is required to submit form details in edit mode.',
      );
    }
    await saveUpdatedFormTemplate({ formTemplate, organizationId });
  }, [
    isEditMode,
    navigateToFieldsStepInCreateMode,
    saveUpdatedFormTemplate,
    formTemplate,
    organizationId,
  ]);

  return onSubmit;
}
